module.exports = __webpack_public_path__ + "img/pt-30.9496165a.svg";